var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.206,
    cy: 13,
    r: 13,
    fill: "#2AA9E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7739 8.40854C20.2312 8.64904 19.6481 8.81154 19.0352 8.88499C19.6676 8.50655 20.1408 7.91094 20.3664 7.20929C19.7722 7.56223 19.1218 7.81067 18.4437 7.94379C17.9876 7.45685 17.3836 7.1341 16.7253 7.02565C16.067 6.91719 15.3913 7.0291 14.8032 7.344C14.215 7.6589 13.7473 8.15917 13.4726 8.76715C13.1979 9.37512 13.1316 10.0568 13.284 10.7063C12.08 10.6458 10.9021 10.3329 9.82689 9.78778C8.75166 9.24266 7.80307 8.47754 7.04267 7.54209C6.78267 7.99059 6.63317 8.51059 6.63317 9.06439C6.63288 9.56294 6.75565 10.0538 6.99059 10.4936C7.22553 10.9333 7.56537 11.3082 7.97997 11.5851C7.49915 11.5698 7.02894 11.4399 6.60847 11.2061V11.2451C6.60842 11.9444 6.85029 12.6221 7.29304 13.1633C7.73579 13.7045 8.35214 14.0758 9.03752 14.2143C8.59148 14.3351 8.12384 14.3528 7.66992 14.2663C7.86329 14.868 8.23997 15.3941 8.74721 15.771C9.25445 16.148 9.86686 16.3569 10.4987 16.3684C9.42611 17.2105 8.10145 17.6672 6.73782 17.6652C6.49627 17.6653 6.25492 17.6511 6.01502 17.6229C7.39918 18.5129 9.01044 18.9852 10.656 18.9834C16.2265 18.9834 19.2718 14.3697 19.2718 10.3683C19.2718 10.2383 19.2685 10.107 19.2627 9.97699C19.855 9.54862 20.3663 9.01817 20.7726 8.41049L20.7739 8.40854Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTwitter);
export default __webpack_public_path__ + "static/media/btnTwitter.d8e609653de8bf3e6f98fd39c6cc38f0.svg";
export { ForwardRef as ReactComponent };